module.exports = __webpack_public_path__ + "54b15ccd146391e0d0984efb683d9911.jpg";